import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

export interface SEOProps {
	title: string,
	description: string
}

export const SEO: React.FunctionComponent<SEOProps> =
	(props) => {
  const { site, logo } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
      logo: file(relativePath: { eq: "star.svg" }) {
	      publicURL
	    }
    }
  `);

  const metaDescription = props.description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
      meta={
      	[
		      {
			      name: `title`,
			      content: props.title,
		      },
	        {
	          name: `description`,
	          content: metaDescription,
	        },
	        {
	          property: `og:title`,
	          content: props.title,
	        },
	        {
	          property: `og:description`,
	          content: metaDescription,
	        },
	        {
	          property: `og:type`,
	          content: `website`,
	        },
		      {
		      	property: `og:image`,
			      content: `https://k3countyvac.com${logo.publicURL}`
		      }
	      ]
      }
      title={props.title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    />
  );
};
